/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Gashari 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Birambo": ["Birambo", "Gashari", "Kabirizi", "Kakibereka", "Kananira", "Ntarabana", "Nyabikenke", "Nyakibuguma", "Nyarusange", "Rugarama"],
  "Musasa": ["Kabasare", "Kaduha", "Kagangare", "Kigarama", "Musasa", "Rasaniro"],
  "Mwendo": ["Gakurwe", "Gataba", "Gihororo", "Kabageni", "Kayogoro", "Nyamigina"],
  "Rugobagoba": ["Karambo", "Karutare", "Kibingo", "Musongati", "Nkingo", "Shungwe"],
  "Tongati": ["Kayonga", "Nyabivumu", "Nyagisozi", "Rubona"]
};